"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.roundPrice = exports.preparePriceForRender = void 0;
var R = _interopRequireWildcard(require("ramda"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var formatPrice = function formatPrice(price) {
  return price.toLocaleString();
};
var isShortCurrencySymbol = function isShortCurrencySymbol(currencySymbol) {
  return currencySymbol.length <= 1;
};
var renderPrice = function renderPrice(priceString) {
  var node = global.document.createElement('div');
  node.innerHTML = priceString;
  return node.textContent;
};
var roundPrice = exports.roundPrice = Math.round;
var preparePriceForRender = exports.preparePriceForRender = function preparePriceForRender(price, currencySymbol) {
  return R.call(R.pipe(roundPrice, formatPrice, R.when(R.always(currencySymbol), R.pipe(function (formatedPrice) {
    return isShortCurrencySymbol(currencySymbol) ? R.join('&thinsp;', [currencySymbol, formatedPrice]) : R.join('&thinsp;', [formatedPrice, currencySymbol]);
  }, renderPrice))), price);
};